export const BG_GRADIENT = 'linear-gradient(90deg, rgba(55, 200, 175, 1), rgba(135, 206, 250, 1))'
